import SchoolCode from "./SchoolCode"

export default  SchoolCode;
